import React from 'react';

import './Title.scss';

const Title = ({ children }) => <h3>{children}</h3>;

export default Title;
